@if(isLoading()) {
<div class="absolute inset-0 z-[10] flex items-center justify-center">
  <mat-spinner></mat-spinner>
</div>
}
